
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorMap as ObiCursorMapElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-map.js';
 
 
 

 
 export const ObiCursorMap = createComponent({
   react: React,
   tagName: 'obi-cursor-map',
   elementClass: ObiCursorMapElement,
   events: {
     
   }
  });
 
 